export default __webpack_public_path__ + "static/media/site.a33b8a1a.webmanifest";